import { render } from "./ClientsRankingTotalValue.vue?vue&type=template&id=6cf09f16&ts=true"
import script from "./ClientsRankingTotalValue.vue?vue&type=script&lang=ts"
export * from "./ClientsRankingTotalValue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__